import VacationCreatePage from './VacationCreatePage';

export default VacationCreatePage;
